module.exports = __webpack_public_path__ + "img/blob3.d1efccf7.svg";